import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const enableGtm = publicRuntimeConfig.enableGtm;

// GTM配置
const GTM_ID = "GTM-5ZJJKZ";

export const setGtmDataLayer = (dataLayer) => {
  if (!enableGtm) return;

  if (!!window) {
    // 初始化 dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayer);
   
    const customScript =  `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');`
    const script = document.createElement('script');
    script.innerHTML = customScript;
    document.head.appendChild(script);
  }
}
